import React from 'react'
import { string } from 'prop-types'

import Icon from '../Icon'
import ShrinkWrap from '../ShrinkWrap'
import ButtonStandard from '../ButtonStandard'
import styles from './ArticleEventButton.module.scss'

const ArticleEventButton = ({ eventRegistrationLink }) => (
  <div className={styles.ButtonWrapper}>
    <ButtonStandard
      outline
      className={styles.ArticleEventButton}
      href={eventRegistrationLink}
      target="_blank"
    >
      <ShrinkWrap>
        <ShrinkWrap.Item>Register now</ShrinkWrap.Item>
        <ShrinkWrap.Item shrink>
          <Icon type="arrow-right" />
        </ShrinkWrap.Item>
      </ShrinkWrap>
    </ButtonStandard>
  </div>
)

ArticleEventButton.propTypes = {
  eventRegistrationLink: string.isRequired
}

export default ArticleEventButton
